<template>
    <div>

        <div v-if="isLoaded">
            <div class="splide" id="dashboard-slide" v-if="arrDashboard.length > 1">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide"
                            v-for="(dashboard, k) in arrDashboard"
                            :key="k"
                            @click="clickDashboard(dashboard, k)">
                            <div class="wrapper-img-dashboard">
                                <img :src="dashboard.imageUrl" alt="">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else>
                <div class="wrapper-img-dashboard" @click="clickDashboard(arrDashboard[0],0)">
                    <img :src="arrDashboard[0].imageUrl" alt="">
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-4 pt-6">
            <div v-for="(dashboard, k) in arrDashboardList"
                :key="k"
                @click="clickDashboard(dashboard, k)"
                class="border rounded-md overflow-hidden cursor-pointer bg-white p-1 shadow-campaign">
                <div class="dashboard-image rounded-md" :style="{'background-image': `url('${dashboard.imageUrl}')`}"></div>
                <div class="">
                    <div class="dashboard-name text-22 text-blue-1">{{dashboard.line1}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager';
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
import { UserLevel } from "@/core/UserLevel/UserLevelDetail.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js"


/**
 * @event onLoaded
 */
export default {
    name: "DashboardList",
    mixins: [AuthStatusMixin],
    props: {
        apiConfig: { type: String, required: true },
        modalController: { type: Object }
    },
    data: function() {
        return {
            arrDashboard: [],
            arrDashboardList: [],
            slider: null,
            currentSliderIndex: 0,
            isLoaded: false,
        };
    },
    created: function() {
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            let configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            let params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, this.apiConfig).subscribe((data) => {
                this.userLevel = new UserLevel();
                for (let dashboard of data) {
                    if (dashboard.subCampaignDetails.length > 0) {
                        for (let subDashboard of dashboard.subCampaignDetails) {
                            if (subDashboard.userVisibility) {
                                for(let subLevel of subDashboard.userVisibility) {
                                    if (this.userLevel.checkLevel(subLevel)) {
                                        this.arrDashboard.push(subDashboard);
                                        break;
                                    }
                                }
                            } else {
                                this.arrDashboard.push(subDashboard);
                            }
                        }
                    } else {
                        if (dashboard.userVisibility) {
                            for(let level of dashboard.userVisibility) {
                                if (this.userLevel.checkLevel(level)) {
                                    this.arrDashboard.push(dashboard);
                                    break;
                                }
                            }
                        } else {
                            this.arrDashboardList.push(dashboard);
                        }
                    }
                }

                if (this.arrDashboard.length > 0) {
                    this.isLoaded = true;
                }

                if(this.arrDashboard.length > 1){
                    this.setSlider();
                }

                console.log(this.arrDashboard[0])

                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
        clickDashboard: function(dashboard, dashboardNumber) {
            if (dashboard.type == 'link') {
                this.tracking.event('activity', 'click_activity', dashboardNumber + '|' + dashboard.url);
                this.checkLoginPopup(() => {
                    let url = dashboard.url;
                    let token = Account.getToken()
                    url = url.replace("{token}", token);
                    if (url.indexOf('friendgetfriend') >= 0) {
                        this.$router.push('/friendgetfriend')
                    } else if (url.indexOf('promocode') >= 0) {
                        this.$router.push(url)
                    } else if (url.indexOf('paywithpoint') >= 0) {
                        this.openPaywithPoint(url)
                    } else {
                        window.open(url, '_blank');
                    }
                })
            } else if (dashboard.type == 'campaign') {
                this.tracking.event('activity', 'click_activity', dashboardNumber + '|' + dashboard.id);
                this.$router.push('/campaign/' + dashboard.id);
            } else if (dashboard.type == 'none') {
                if(dashboard.line1 && dashboard.line2){
                    if (dashboard.line3) {
                        this.$router.push('/surprisebox/' + dashboard.line1 + '/' + dashboard.line2 + '?verifycode=' + dashboard.line3);
                    }else {
                        this.$router.push('/surprisebox/' + dashboard.line1 + '/' + dashboard.line2);
                    }
                }
            }
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#dashboard-slide', {
                    type: 'loop',
                    arrows: false,
                    padding: '30px',
                    gap: '10px',
                }).mount();
                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex;
                });
            });
        },
        openPaywithPoint: function(urlInterface) {
            let appId = ConfigManager.getAppId();
            let theme = ConfigManager.getAppName();
            let locale = Locale.getLocaleCode();
            let suffledToken = Account.getTokenShuffle();
            let returnUrl = window.location.href;

            let url = urlInterface
                +'&app_id=' + appId
                +'&theme=' + theme
                +'&locale=' + locale
                +'&token=' + suffledToken
                +'&return_url=' + encodeURIComponent(returnUrl);

            window.location = url;
        }
    },
}
</script>
<style lang="scss">
    #dashboard-slide {
        .splide__slide {
            &.is-active {
                .wrapper-img-dashboard {
                    img {
                        height: 100%;
                        width: 100%;
                        margin-top: 0;
                        margin-left: 0;
                    }
                }
            }

            &.is-prev {
                .wrapper-img-dashboard {
                    img {
                        margin: 20px 0px 0px 20px;
                    }
                }
            }

            .wrapper-img-dashboard {
                img {
                    height: calc(100% - 20px);
                    width: calc(100% - 20px);
                    margin-top: 20px;
                }
            }
        }
        .splide__pagination {
            bottom: -20px;
            .splide__pagination__page {
                &.is-active {
                    background-color: #53b546;
                    transform: none;
                }

                background-color: #979797;
                width: 4px;
                height: 4px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    @import "@/style/base/image.scss";
    .dashboard-image {
        @include boxRatio($ratio: 66.66%);
    }
    .dashboard-name {
        height: 52px;
        @extend %ellipsis-2;
    }
    .wrapper-img-dashboard {
        @include baseRatioImg($ratio: 50%);
        img {
            border-radius: 6px;
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.12);
            overflow: hidden;
        }
    }
</style>
